import { useLocation, useNavigate } from "react-router-dom";
import { useUser } from "@/providers/context";
import { useCallback } from "react";
import { CollectionItem } from "@/api";

interface RedirectProps {
  parentId?: number | string | null; // Required for videos to show up next
  item: Pick<CollectionItem, "Type" | "ChildId">;
}

export const useRedirectGatedContent = () => {
  const navigate = useNavigate();
  const { uid } = useUser();
  const isSignedIn = !!uid;

  const { search } = useLocation();

  const getRedirectPath = useCallback(
    ({ item }: RedirectProps) => {
      if (item.Type === "collection" || item.Type === "tab") {
        // Collections are only redirect when locked until sign in
        return `/sign-up?redirect=/collection/${item.ChildId}`;
      } else if (item.Type === "video") {
        if (isSignedIn) {
          // You have an account, but no subscription, buy one
          return `/for-sale`;
        } else {
          // Gated Sign-Up to Video Details
          const query = new URLSearchParams(search);
          const parent_id = query.get("parent_id");
          const queryParams = parent_id ? `?parent_id=${parent_id}` : "";
          return `/sign-up?redirect=/video/${item.ChildId}${queryParams}`;
        }
      } else {
        const path = `${item.Type}/${item.ChildId}`;
        if (isSignedIn) {
          // You have an account, but no subscription, buy one
          return `/for-sale`;
        } else {
          // Gated Sign-Up to Video Details
          return `/sign-up?redirect=${path}`;
        }
      }
    },
    [isSignedIn, search],
  );

  const redirectForGatedContent = useCallback(
    ({ parentId, item }: RedirectProps) => {
      const path = getRedirectPath({ parentId, item });
      navigate(path);
    },
    [getRedirectPath, navigate],
  );

  return { redirectForGatedContent, getRedirectPath };
};
